var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"canvas-container",attrs:{"elevation":"5"}},[_c('v-responsive',{attrs:{"aspect-ratio":16/9}},[_c('Canvas')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }